var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './index.scss';
import React, { forwardRef } from 'react';
import { createPortal } from 'react-dom';
const Menu = forwardRef((props, ref) => {
    const { showMenu, setShowMenu, targetRef, onMenuItemClick, menuItems } = props;
    const handleMenuItemClick = (e, item) => __awaiter(void 0, void 0, void 0, function* () {
        e.stopPropagation();
        e.preventDefault();
        setShowMenu(false);
        onMenuItemClick(item);
    });
    const rootElement = document.getElementById('root');
    if (rootElement === null || targetRef === null)
        return React.createElement(React.Fragment, null);
    if (!showMenu)
        return null;
    const dimensions = targetRef.getBoundingClientRect();
    const arrowHeight = 10;
    const width = 175;
    const left = (dimensions.left - 25 + width < window.innerWidth)
        ? dimensions.left - 25
        : (window.innerWidth - width - 10);
    const menuHeight = (33 * menuItems.length) + 14;
    const isTooCloseToBottom = (window.innerHeight - dimensions.bottom) < (menuHeight + 20);
    const top = isTooCloseToBottom
        ? dimensions.top - menuHeight
        : dimensions.bottom + arrowHeight;
    const renderMenuItems = (items) => items.map((item) => {
        var _a;
        return (React.createElement("div", { key: item.key ? item.key : item.name, className: 'menu-item', title: item.name, onClick: (e) => handleMenuItemClick(e, item.key ? item.key : item.name) },
            React.createElement("span", null, (_a = item.component) !== null && _a !== void 0 ? _a : item.name)));
    });
    return createPortal(React.createElement("div", { ref: ref, className: 'menu-container', style: { left: left, top, width: `${width}px` } }, renderMenuItems(menuItems)), rootElement);
});
export default Menu;
